<template>
    <div class="o-slider o-slider--dashboard">
        <!-- eslint-disable vue/no-v-text-v-html-on-component -->
        <tiny-slider
            v-html="sliderHtml"
            class="dashboard-slider flex-grow-1"
            ref="dashboard-slider"
            prevent-scroll-on-touch="auto"
            data-dashboard-slider
            :items="1"
            :slide-by="1"
            :autoplay="true"
            :mouse-drag="true"
            :center="true"
            :gutter="0"
            :edge-padding="0"
            :autoplay-button-output="false"
            :controls="true"
            :nav="true"
        />
        <!-- eslint-enable vue/no-v-text-v-html-on-component -->

        <modal-preview
            v-if="preview"
            ref="modal-preview"
            @close="preview = null"
        >
            <div class="dashboard-preview__preview" ref="preview" v-html="preview" />
        </modal-preview>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
import { tour } from '@/walkthroughs/promoAccept'

export default {
    components: {
        TinySlider: VueTinySlider
    },
    props: {
        data: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            sliderHtml: '',
            preview: null
        }
    },
    methods: {
        updateAutoplayTimeout(slider) {
            const autoplayTimeOutEl = slider.querySelector('[autoplay-timeout]')
            if (!autoplayTimeOutEl) {
                return
            }

            const autoplayTimeOut = autoplayTimeOutEl.getAttribute('autoplay-timeout')
            if (!autoplayTimeOut) {
                return
            }

            this.tinySliderOptions['autoplay-timeout'] = +autoplayTimeOut
        },

        prepareSliderHtml() {
            const slider = document.createElement('div')
            slider.innerHTML = (this.data || '').trim()

            this.updateAutoplayTimeout(slider)

            this.sliderHtml = slider.innerHTML
        },

        addButtonsListeners() {
            const slider = this.$refs['dashboard-slider'].$el
            const slides = slider.querySelectorAll('.dashboard-slide')

            for (const slide of slides) {
                const button = slide.querySelector('button')

                // Get element which has property preview
                const preview = slide.querySelector('[ep-preview]')
                if (preview) {
                    // Cut off iframe
                    preview.remove()
                }

                if (!button) {
                    continue
                }

                if (preview) {
                    button.addEventListener('click', () => {
                        this.preview = preview.outerHTML
                    })
                } else if (button.classList.contains('samouczek')) {
                    button.addEventListener('click', () => {
                        if (this.$router.currentRoute.name !== 'dashboard') {
                            this.$router.push({ name: 'dashboard' })
                        }
                        tour.start()
                    })
                } else if (button.attributes.link) {
                    button.addEventListener('click', () => {
                        if (button.attributes.moduleName && button.attributes.filters) {
                            const filters = JSON.parse(button.attributes.filters.value)
                            for (const [key, value] of Object.entries(filters)) {
                                this.$store.dispatch('setFilter', {
                                    moduleName: button.attributes.moduleName.value,
                                    filter: key,
                                    value
                                })
                            }
                        }
                        this.$router.push(button.attributes.link.value)
                    })
                }
            }
        },

        setPreviewSizes() {
            const container = this.$refs.preview
            const preview = container.firstElementChild

            const width = preview.width || preview.offsetWidth
            const height = preview.height || preview.offsetHeight

            // Calculate ratio: height / width * 100
            const aspectRatio = (height / width) * 100

            // Set container's padding-top of based on proporcji
            container.style.paddingTop = `${aspectRatio}%`
            container.style.width = width + 'px'

            const modal = this.$refs['modal-preview'].$el
            const wrapperHeight = modal.querySelector('.modal-preview__wrapper').clientHeight
            const headerHeight = modal.querySelector('.modal-preview__header').clientHeight
            const footerHeight = modal.querySelector('.modal-preview__footer').clientHeight
            const availableHeight = wrapperHeight - headerHeight - footerHeight

            if (container.clientHeight > availableHeight) {
                // If container's height is bigger than available space, set it to 100%
                container.style.width = availableHeight / aspectRatio * 100 + 'px'
            }
        },

        showPreview() {
            this.previewVisible = true
        }
    },
    created() {
        this.prepareSliderHtml()
    },
    mounted() {
        this.addButtonsListeners()
    },
    watch: {
        preview() {
            if (this.preview) {
                this.$nextTick(() => {
                    this.setPreviewSizes()
                })
            }
        }
    }
}
</script>

<style lang="scss">
@import 'tiny-slider/src/tiny-slider';

.dashboard-preview {
    &__preview {
        position: relative;
        max-width: 100%;
        width: 100%;
        height: 0;

        // first child
        & > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
}
</style>
